<template>
	<div class="stretch-layout">
		<title-bar with-search :title="$t('param_label.events', total, {count: total})"
				   flat v-model="filter.search"/>

		<data-loader :url="`/v1/clubs/${clubStore.club.id}/events`" id="results"
					 :filter="filter"
					 v-model:total="total"
					 :persist-filter-keys="['search']"
					 :params="params"
					 as-guest
					 :simple-paginated="false">

			<template #loading>
				<container custom-padding="px-8 md:px-0">
					<row tight>
						<column cols="6" sm="6" md="4" lg="3" v-for="eventLoader in 4" :key="'event-loader-' + eventLoader">
							<event-card-skeleton/>
						</column>
					</row>
				</container>
			</template>

			<template v-slot="{data}">
				<container custom-padding="px-8 md:px-0">
					<row tight v-adapt:height="'.event-card'">
						<column cols="6" sm="6" md="4" lg="3" v-for="(event, eventKey) in data" :key="'event-card-' + eventKey">
							<event-card :to="$web('events.show', event._key)" :event="event" :position="eventKey+1" class="event-card" list-name="Club Event List"/>
						</column>
					</row>
				</container>
			</template>

			<template #missingsearch>
				<missing-info card xs-tile sm-tile class="flex-grow-1" :text="$t('missing.event.search')"/>
			</template>
			<template #missing>
				<missing-info card xs-tile sm-tile class="flex-grow-1"
							  :text="$t('missing.club.events', {name: clubStore.club.display_name})"/>
			</template>

		</data-loader>
	</div>
</template>

<script setup lang="ts">
import {EventClubType} from "@spoferan/spoferan-ts-core";
import {useClubStore} from "../../../../store/club";

const clubStore = useClubStore();
const route = useRoute();
const {t} = useI18n();

const total = ref(0);
const filter = ref({
	// The query to search for a specific event
	search: route.query.search
});

const params = computed(() => {
	return {club_type: EventClubType.Organizer}
});

useMeta({
	title: clubStore.buildPageTitle(t('view.clubs.events.index.title', {club: clubStore.club.display_name})),
	description: t('view.clubs.events.index.description', {club: clubStore.club.display_name}),
})

</script>

